import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { orderDetailDispatchers } from 'reduxModules/users/dispatchers'
import _ from 'lodash'
import classnames from 'classnames'
import math from 'reduxModules/utils/math'
import utils from '../../utils/cartItemUtils'
import AddressDetails from '../AddressDetails'
import PaymentMethodDetails from '../PaymentMethodDetails'
import './styles.css'

export class OrderDetail extends Component {
  static getSubtotal(items) {
    return math.toFixed(
      parseFloat(
        items.reduce((acc, item) => acc + item.regularPrice * item.quantity, 0)
      )
    )
  }

  componentDidMount() {
    const { isLoaded, loadOrderDetail, id } = this.props
    if (!isLoaded) loadOrderDetail(id)
  }

  render() {
    const {
      subscriptionTransaction: subOrder,
      items,
      isMobile,
      width,
      showFullDetail,
      shippingAddress,
      creditCard,
      paypalAccount,
      creditCardDetails,
      paypalDetails,
      billingAddress,
      discounted,
      itemsCost,
      shippingCost,
      taxAmount,
      taxPctg,
      cost,
      amount,
      subscription
    } = this.props

    return (
      <div className="order-description">
        {!isMobile && (
          <div className="items-header">
            <div className="item-name">items</div>
            {!subOrder && <div className="quantity">{width < 980 ? 'qt' : 'quantity'}</div>}
            <div className="item-price">price</div>
          </div>
        )}
        <div className="items">
          {!subOrder && items.map((item) => (
            <div className="item" key={item.id}>
              <div className="item-name">
                <div className="type blue">
                  <span>{utils.getNaturalType(item.orderedModel, item.ordered)}</span>
                </div>
                <div className="title">
                  <span>{utils.getTitle(item.orderedModel, item.ordered)}</span>
                </div>
              </div>
              <div className="quantity">{item.quantity}</div>
              <div className="item-price">${math.toFixed(item.price * item.quantity)}</div>
            </div>
          ))}
          {subOrder && (
            <div className="item">
              <div className="item-name">
                <div className="type blue">
                  <span>Subscription</span>
                </div>
                {_.has(subscription, 'plan') && (
                  <div className="title">
                    <span>Subscription renewal</span>
                  </div>
                )}
              </div>
              <div className="item-price">${math.toFixed(amount)}</div>
            </div>
          )}
        </div>
        <div className={classnames('bottom-section', { simplified: !showFullDetail })}>
          {showFullDetail && (
            <div className="full-details">
              {shippingAddress && (
                <div className="shipping-info">
                  <div className="small-header">
                    <span>shipped to</span>
                  </div>
                  <AddressDetails {...shippingAddress} />
                </div>
              )}
              {(_.isObject(creditCard) || _.isObject(paypalAccount)) && (
                <div className={classnames('payment-info', { 'only-payment-method': !shippingAddress })}>
                  <div className="small-header">
                    <span>payment method</span>
                  </div>
                  <PaymentMethodDetails creditCardPayment={creditCard} paypalPayment={paypalAccount} />
                </div>
              )}
              {subOrder && (
                <div className="payment-info">
                  <div className="small-header">
                    <span>payment method</span>
                  </div>
                  <PaymentMethodDetails creditCardPayment={creditCardDetails} paypalPayment={paypalDetails} />
                </div>
              )}
              {billingAddress && billingAddress.firstName && (
                <div className="billing-info">
                  <div className="small-header">
                    <span>billed to</span>
                  </div>
                  <AddressDetails {...billingAddress} />
                </div>
              )}
            </div>
          )}
          {!subOrder && (
            <div className="order-details">
              <div className="small-header">order details</div>
              {!_.isEmpty(items) && (
                <div className="order-details-container">
                  <div className="order-details-items">
                    {discounted && discounted !== '0.00' && <div>Discount</div>}
                    <div>Items total:</div>
                    {shippingCost !== '0.00' && <div>Shipping:</div>}
                    {((taxAmount && taxAmount !== '0.00') || (taxPctg && taxPctg !== '0.00')) && <div>Taxes:</div>}
                  </div>
                  <div className="order-details-values">
                    {discounted && discounted !== '0.00' && <div>-${math.toFixed(Math.abs(discounted))}</div>}
                    <div>${math.toFixed(itemsCost)}</div>
                    {shippingCost !== '0.00' && <div>${math.toFixed(shippingCost)}</div>}
                    <div className="taxes-amount">
                      {taxPctg && taxPctg !== '0.00' && <div>%{taxPctg}</div>}
                      {taxAmount && taxAmount !== '0.00' && <div className="tax-divider">-</div>}
                      {taxAmount && taxAmount !== '0.00' && <div>${taxAmount}</div>}
                    </div>
                  </div>
                </div>
              )}
              <div className="order-total">
                <div>order total:</div>
                <div>${math.toFixed(subOrder ? amount : cost)}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

OrderDetail.propTypes = {
  isLoaded: PropTypes.bool,
  loadOrderDetail: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ),
  subscriptionTransaction: PropTypes.bool,
  isMobile: PropTypes.bool,
  width: PropTypes.number,
  showFullDetail: PropTypes.bool,
  shippingAddress: PropTypes.object,
  creditCard: PropTypes.object,
  paypalAccount: PropTypes.object,
  creditCardDetails: PropTypes.object,
  paypalDetails: PropTypes.object,
  billingAddress: PropTypes.object,
  discounted: PropTypes.string,
  itemsCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shippingCost: PropTypes.string,
  taxAmount: PropTypes.string,
  taxPctg: PropTypes.string,
  cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subscription: PropTypes.object
}

OrderDetail.defaultProps = {
  items: [],
  id: '',
  isLoaded: false,
  subscriptionTransaction: false,
  isMobile: false,
  width: 0,
  showFullDetail: false,
  shippingAddress: null,
  creditCard: null,
  paypalAccount: null,
  creditCardDetails: null,
  paypalDetails: null,
  billingAddress: null,
  discounted: '0.00',
  itemsCost: '0.00',
  shippingCost: '0.00',
  taxAmount: '0.00',
  taxPctg: '0.00',
  cost: '0.00',
  amount: '0.00',
  subscription: null
}

export default connect(
  null,
  orderDetailDispatchers
)(OrderDetail)
